import { render, staticRenderFns } from "./TransferGoodsdetail.vue?vue&type=template&id=8c3871f6&scoped=true&"
import script from "./TransferGoodsdetail.vue?vue&type=script&lang=js&"
export * from "./TransferGoodsdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3871f6",
  null
  
)

export default component.exports